import React from 'react';
import Type from 'prop-types';
import styles from './FilterItem.module.css';

const FilterItem = (props) => {
  const { header, children } = props;

  return (
    <div className={styles.filterItem} data-testid="filterItemWrapper">
      <div className={styles.header} data-testid="flterItemHeader">
        {header}
      </div>
      {children}
    </div>
  );
};

FilterItem.propTypes = {
  header: Type.string.isRequired,
  children: Type.node.isRequired,
};

export default FilterItem;
